import { Deserializable } from '../../../protocols/deserializable';
import { CreateAttachmentRequest } from '../create-attachment-request';

export abstract class SubmissionRequest implements Deserializable {
  memberId!: number;
  attachments: CreateAttachmentRequest[] = [];

  public onDeserialize(): void {}
}
